// @flow
import * as React from 'react';
import { H2, Body } from 'components/Text';
import { AmpVideo } from 'components/Video';
import type { VideoBlockData } from 'api/cms';

const VideoBlock = ({
  data: { headline, subtitle, videoUrl }
}: {
  data: VideoBlockData
}) => (
  <>
    {headline && <H2>{headline}</H2>}
    {subtitle && <Body dangerouslySetInnerHTML={{ __html: subtitle }} />}
    <AmpVideo url={videoUrl} />
  </>
);

export default VideoBlock;
